<template>
    <div class="landing-page-outer">
        <!-- Top navbar -->
        <landing-page-navbar/>

        <ee-landing-page v-if="partnerEnvironment === 'ee'"/>
        <o2-landing-page v-if="partnerEnvironment === 'o2'"/>
        <tesco-mobile-landing-page v-if="partnerEnvironment === 'tesco'"/>
        <three-landing-page v-if="partnerEnvironment === 'three'"/>
        <vodafone-landing-page v-if="partnerEnvironment === 'vodafone'"/>

        <wefix-au-landing-page v-if="partnerEnvironment === 'wefix-au'"/>
        <wefix-us-landing-page v-if="partnerEnvironment === 'wefix-us'"/>
        <wefix-ca-landing-page v-if="partnerEnvironment === 'wefix-ca'"/>
        <wefix-landing-page v-if="partnerEnvironment === 'wefix' || partnerEnvironment === 'samsungrepair' || partnerEnvironment === 'samsungrepair-de' || partnerEnvironment === 'appliance'"/>

        <likewize-repair-landing-page v-else-if="partnerEnvironment === 'likewize' || partnerEnvironment === 'likewize-au' || partnerEnvironment === 'likewize-us'"/>
        <likewize-confirm-landing-page v-else-if="partnerEnvironment === 'likewize-confirm'"/>

        <!-- Footer -->
        <page-footer/>
    </div>
</template>

<script>

if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
    require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
    require('@/styles/core/whitelabel/wefix.scss');
}

import {mapActions, mapGetters} from "vuex";

export default {
    name: "LandingPageIndex",

    mounted() {
        this.checkBooking().then(() => {
            this.checkBookingIsComplete();
        });
    },

    computed: {
        ...mapGetters([
            'partnerEnvironment'
        ])
    },

    methods: {
        ...mapActions([
            'checkBooking',
            'checkBookingIsComplete'
        ])
    }
}
</script>

<style>
.landing-page-outer{
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>